import { render, staticRenderFns } from "./selectInsertionDesignTutorial.vue?vue&type=template&id=f317be7e&"
import script from "./selectInsertionDesignTutorial.vue?vue&type=script&lang=ts&"
export * from "./selectInsertionDesignTutorial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports